// Expert section - обработка кликов на кнопки WhatsApp и звонка
document.addEventListener('DOMContentLoaded', function() {
    // Обработчик для кнопки WhatsApp
    const whatsappBtn = document.querySelector('.expert-btn-whatsapp[data-phone]');
    if (whatsappBtn) {
        whatsappBtn.addEventListener('click', function(e) {
            e.preventDefault();
            const phone = this.getAttribute('data-phone');
            if (phone) {
                // Очищаем номер от всех символов кроме цифр
                const cleanPhone = phone.replace(/[^\d]/g, '');
                if (cleanPhone) {
                    window.open('https://wa.me/' + cleanPhone, '_blank');
                }
            }
        });
    }
    
    // Кнопка "Позвонить" уже работает через href="tel:", но можно добавить обработчик для мобильных устройств
    const callBtn = document.querySelector('.expert-btn-call');
    if (callBtn) {
        // На мобильных устройствах tel: ссылки работают автоматически
        // Здесь можно добавить дополнительную логику если нужно
    }
});











